import React, { useEffect } from "react"

const ApiDocs = () => {
  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://cdn.redoc.ly/redoc/latest/bundles/redoc.standalone.js"

    script.onload = () => {
      window.Redoc.init(
        "/openapi.yaml",
        {
          scrollYOffset: 0,
          menuToggle: true,
          theme: {
            colors: { primary: { main: "#FF5B1F" } },
            sidebar: {
              groupItems: { textTransform: "uppercase" },
              level1Items: { textTransform: "none" },
            },
            typography: { fontWeightBold: "700" },
          }
        },
        document.getElementById("redoc-container"),
        () => {
          // Fix sticky sidebar
          const style = document.createElement("style")
          style.innerHTML = `
            .redoc-wrap {
              align-items: flex-start !important;
            }
            .menu-content {
              position: sticky !important;
              top: 0 !important;
              height: 100vh !important;
              overflow-y: auto !important;
            }
          `
          document.head.appendChild(style)

          // Fix overflow:hidden ancestor blocking sticky
          document.querySelectorAll('div').forEach(el => {
            if (el.classList.contains('overflow-hidden') && el.classList.contains('mt-12')) {
              el.style.overflow = 'visible'
            }
          })

          // Hover highlight and text color for all menu labels
          document.querySelectorAll('.menu-content li > label').forEach(label => {
            label.addEventListener('mouseenter', () => {
              label.style.setProperty('background-color', 'rgba(0, 0, 0, 0.1)', 'important')
              label.style.setProperty('color', '#FF5B1F', 'important')
            })
            label.addEventListener('mouseleave', () => {
              label.style.removeProperty('background-color')
              label.style.removeProperty('color')
            })
          })

          const applyBold = () => {
            document.querySelectorAll('li.kdEFVV > label > span').forEach(el => {
              el.style.setProperty('font-weight', '700', 'important')
            })
          }
          applyBold()
          setTimeout(applyBold, 500)

          setTimeout(() => {
            document.querySelectorAll('li.kdEFVV').forEach(group => {
              const subList = group.querySelector('ul')
              if (!subList) return
              subList.style.display = 'none'
              const label = group.querySelector('label')
              if (label) {
                label.style.cursor = 'pointer'
                label.addEventListener('click', (e) => {
                  e.stopPropagation()
                  const isHidden = subList.style.display === 'none'
                  subList.style.display = isHidden ? 'block' : 'none'
                })
              }
            })
          }, 800)
        }
      )
    }

    document.body.appendChild(script)
    return () => document.body.removeChild(script)
  }, [])

  return (
    <div style={{
      width: '100vw',
      marginLeft: 'calc(-50vw + 50%)',
      marginRight: 'calc(-50vw + 50%)',
    }}>
      <div id="redoc-container"></div>
    </div>
  )
}

export default ApiDocs